import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/smile': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM332 312.6c8.5-10.2 23.7-11.5 33.8-3.1 10.2 8.5 11.6 23.6 3.1 33.8-30 36-74.1 56.6-120.9 56.6s-90.9-20.6-120.9-56.6c-8.4-10.2-7.1-25.3 3.1-33.8 10.1-8.4 25.3-7.1 33.8 3.1 20.8 25.1 51.5 39.4 84 39.4s63.2-14.4 84-39.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/smile.js
// module id = 1815
// module chunks = 0